import React from "react";
import { BaseLayoutStyled } from "./BaseLayoutStyled";
import { Header } from "../components";
var BaseLayout = function (_a) {
    var children = _a.children;
    return (React.createElement(BaseLayoutStyled, null,
        React.createElement(Header, null),
        React.createElement("main", null, children)));
};
export default BaseLayout;
//# sourceMappingURL=BaseLayout.js.map